import { useSelector } from 'react-redux'
import { DATE_BIRTH_VARIANTS } from '../../../constants/uiConfig'
import DateBirthV1 from './DateBirthV1'
import DateBirthV2 from './DateBirthV2'

/**
 * A factory component that renders different versions of the DateBirth
 * component based on the dateBirthVariant value from UI config.
 *
 * @param {Object} props - Component props
 * @param {Object} props.formik - Formik instance
 * @param {Object} props.contextValue - Context value containing regFields
 * @param {boolean} props.disabled - Whether the date picker is disabled
 *
 * Defaults to V1 for backward compatibility.
 */
const DateBirth = (props) => {
  const variant = useSelector(state => state?.uiConfig?.general?.dateBirthVariant) || DATE_BIRTH_VARIANTS.V1

  if (variant === DATE_BIRTH_VARIANTS.V2) {
    return <DateBirthV2 {...props} />
  }

  return <DateBirthV1 {...props} />
}

export default DateBirth
